import {Box, LinkButton, Modal, Typography} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import {i18n} from 'src/shared/config'

import * as classes from './BusinessBannerModal.classes'
import {useBusinessBannerModal} from './hooks'
import type {Props} from './types'

export const BusinessBannerModal = memo<Props>(function BusinessBannerModal(props) {
  const {onActionButtonClick} = props
  const {opened, onClose, title, list, description, imageSrc, link} = useBusinessBannerModal(props)

  return (
    <Modal className={classes.modal} data-e2e="business-modal" onClose={onClose} opened={opened}>
      <Modal.Header
        pb="s"
        pl="l"
        pr="xl"
        pt="xl"
        renderTitle={(a11yProps, typographyProps) => (
          <Typography color="invert" group="loose" id={a11yProps.id} mt="s" thickness="bold" variant="title2">
            {typographyProps.children}
          </Typography>
        )}
        title={title}
      />
      <Modal.Body className={classes.body} px="l">
        <Typography color="invert" group="loose" variant="body1">
          {description}
        </Typography>
        {list.length > 0 ? (
          <Typography color="invert" group="loose" ml="xl" mt="m" variant="body1">
            <ul>
              {list.map((text, i) => (
                <li key={i}>{text}</li>
              ))}
            </ul>
          </Typography>
        ) : null}
        <Box className={classes.image} mt="m" style={{backgroundImage: `url(${imageSrc})`}} />
      </Modal.Body>
      <Modal.Footer className={classes.footer} p="s">
        <LinkButton
          data-e2e="account-registration"
          href={link}
          onPress={onActionButtonClick}
          variant="floating"
          fullWidth
        >
          {i18n('order.banner.button.register', 'Зарегистрироваться')}
        </LinkButton>
      </Modal.Footer>
    </Modal>
  )
})
